export const GET_PATIENT_INFORMATION = "patient/GET_INFORMATION";
export const GET_PATIENT_CASES = "patient/GET_CASES";
